import React from 'react';
import ReactDOM from 'react-dom/client';
import { ModalProvider } from '@ui';
import { clarityUtil, redirectToCanonicalAppUrl } from '@utils';
import { ConfigProvider } from 'antd';
import { Provider } from 'mobx-react';
import { CampaignWizardFormProvider } from './pages/CampaignWizard/form';
import store from './_store';
import App from './App';
import config from './config';
import { GlobalStyles } from './GlobalStyles';
import { THEME } from './theme';
// @klickly/klickly-templates >=2.x stopped bundling these (broke SSR consumers) — imported here instead.
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

if (!redirectToCanonicalAppUrl(config.appUrl)) {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    clarityUtil.init();
    root.render(
        <Provider store={store}>
            <GlobalStyles />
            <ConfigProvider theme={THEME}>
                <ModalProvider>
                    <CampaignWizardFormProvider>
                        <App />
                    </CampaignWizardFormProvider>
                </ModalProvider>
            </ConfigProvider>
        </Provider>
    );
}
